export const _setRefreshEpisodeParticipant = (state, action) => {
  state.refreshEpisodeParticipant = action.payload;
};